// Single source of truth for PEME pipeline stages
import { ShieldCheck, FlaskConical, Phone, Stethoscope, ClipboardCheck, CheckCircle2 } from 'lucide-react';

export const PIPELINE_STAGES = [
  'Dental Clearance',
  'Lab Sent Out',
  "Doctor's Feedback Call",
  'Initial Medical Evaluation',
  'Final Medical Evaluation',
  'Fit to Work',
];

// Icon and color config per stage (keyed by stage name)
export const STAGE_CONFIG = {
  'Dental Clearance': { icon: ShieldCheck, bg: 'tw-bg-emerald-50', color: 'tw-text-emerald-500' },
  'Lab Sent Out': { icon: FlaskConical, bg: 'tw-bg-amber-50', color: 'tw-text-amber-500' },
  "Doctor's Feedback Call": { icon: Phone, bg: 'tw-bg-blue-50', color: 'tw-text-blue-500' },
  'Initial Medical Evaluation': { icon: Stethoscope, bg: 'tw-bg-pink-50', color: 'tw-text-pink-500' },
  'Final Medical Evaluation': { icon: ClipboardCheck, bg: 'tw-bg-orange-50', color: 'tw-text-orange-500' },
  'Fit to Work': { icon: CheckCircle2, bg: 'tw-bg-emerald-50', color: 'tw-text-emerald-500' },
};
